import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ComponentErrorBoundaryProps {
  children: ReactNode;
  fallback: (error: Error) => ReactNode;
  resetKey?: string;
  onError?: (error: Error, info: ErrorInfo) => void;
}

interface ComponentErrorBoundaryState {
  error: Error | null;
}

export class ComponentErrorBoundary extends Component<ComponentErrorBoundaryProps, ComponentErrorBoundaryState> {
  state: ComponentErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): ComponentErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    this.props.onError?.(error, info);
  }

  componentDidUpdate(prevProps: ComponentErrorBoundaryProps): void {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      return this.props.fallback(this.state.error);
    }

    return this.props.children;
  }
}
